/*
  Don't use this function directly. Use `copyTextToClipboard` instead
*/

import type { CopyTextToClipboard } from '../../../types/clipboard';

const write: CopyTextToClipboard = (...args) => navigator.clipboard.writeText(...args);

export default write;
